import { Base } from 'layouts'
import { ProtocolsForm } from 'components'

import * as S from './styled'

export function ProtocolsRegister() {
  return (
    <Base>
      <S.GridContainer container>
        <ProtocolsForm />
      </S.GridContainer>
    </Base>
  )
}
